module.exports = __webpack_public_path__ + "static/media/breastfeeding.411b4ac8.png";